export default "__VITE_ASSET__EMYfuvZ4__"